// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 GET /api/visit1 */
export async function visit1ControllerGetList(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit1ControllerGetListParams,
	options?: { [key: string]: any }
) {
	return request<API.PaginatedDto & { results?: API.Visit1ListResponse[] }>(
		'/api/visit1',
		{
			method: 'GET',
			params: {
				// page has a default value: 1
				page: '1',
				// size has a default value: 10
				size: '10',

				...params,
			},
			...(options || {}),
		}
	);
}

/** 此处后端没有提供注释 PUT /api/visit1 */
export async function visit1ControllerUpdate(
	body: API.Visit1UpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/visit1', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/visit1/${param0} */
export async function visit1ControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit1ControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.Visit1ViewResponse>(`/api/visit1/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/visit1/${param0} */
export async function visit1ControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit1ControllerCreateParams,
	body: API.Visit1CreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/visit1/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}

/** delete visit1 DELETE /api/visit1/${param0} */
export async function visit1ControllerRemove(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit1ControllerRemoveParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/visit1/${param0}`, {
		method: 'DELETE',
		params: { ...queryParams },
		...(options || {}),
	});
}
